import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=9480cf18&"
import script from "./PageSizeSelect.vue?vue&type=script&lang=ts&"
export * from "./PageSizeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports